function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlimitedArtists = function SvgUnlimitedArtists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5399 98.449L80.4607 102.176L78.8207 107.422C78.5261 108.364 77.5176 108.892 76.5752 108.598L68.0758 105.941C67.1334 105.646 66.6053 104.637 66.8999 103.695L68.5399 98.449Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1116 109.302C76.8727 109.302 76.6337 109.264 76.3884 109.189L67.8858 106.529C66.6092 106.132 65.8985 104.768 66.2947 103.497L68.1248 97.655L81.2497 101.755L79.4197 107.598C79.0989 108.629 78.1367 109.296 77.1053 109.296L77.1116 109.302ZM68.9549 99.2335L67.5022 103.875C67.3135 104.485 67.6531 105.139 68.2632 105.334L76.7657 107.994C77.3758 108.183 78.0298 107.843 78.2248 107.233L79.6775 102.592L68.9549 99.2398V99.2335Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6038 42.734L101.478 48.9469L85.1772 101.09C84.7456 102.471 83.2722 103.242 81.8917 102.81L67.0237 98.1625C65.6431 97.731 64.8716 96.2576 65.3032 94.877L81.6038 42.734Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.671 103.56C82.344 103.56 82.0169 103.51 81.6962 103.409L66.8293 98.7619C65.1187 98.2274 64.1628 96.4036 64.6974 94.693L81.1868 41.9481L102.261 48.5389L85.7714 101.284C85.5136 102.114 84.9476 102.793 84.1803 103.196C83.7087 103.441 83.193 103.567 82.6773 103.567L82.671 103.56ZM82.0107 43.5203L65.8985 95.0641C65.5715 96.1143 66.1564 97.2337 67.2066 97.5607L82.0735 102.208C82.5829 102.365 83.1238 102.315 83.5955 102.07C84.0671 101.825 84.413 101.41 84.5702 100.9L100.682 49.3564L82.0107 43.5203Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.528 24.3124L90.1511 18.8801C87.267 17.9785 84.1981 19.5856 83.2964 22.4697L78.7967 36.8635C77.8951 39.7476 79.5022 42.8165 82.3863 43.7181L99.7633 49.1504C102.647 50.052 105.716 48.4449 106.618 45.5608L111.118 31.167C112.019 28.2829 110.412 25.214 107.528 24.3124Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.393 50.0293C100.789 50.0293 100.179 49.9412 99.5755 49.7526L82.193 44.319C80.6396 43.8347 79.3693 42.7719 78.6083 41.3255C77.8537 39.8853 77.7027 38.2313 78.1933 36.678L82.6961 22.2764C83.7023 19.0691 87.1298 17.2705 90.3371 18.2767L107.713 23.7103C110.921 24.7102 112.719 28.1377 111.713 31.3513L107.21 45.7528C106.393 48.3564 103.984 50.0293 101.387 50.0293H101.393ZM88.5133 19.2578C87.7398 19.2578 86.9788 19.4464 86.2745 19.8112C85.1299 20.4086 84.2872 21.4211 83.8973 22.6538L79.3944 37.0553C79.0108 38.2879 79.124 39.596 79.7278 40.7469C80.3252 41.8915 81.3377 42.7342 82.5703 43.1241L99.9528 48.5577C102.5 49.3501 105.223 47.9288 106.015 45.3818L110.518 30.9803C111.317 28.4333 109.889 25.7102 107.342 24.9178L89.9661 19.4779C89.4881 19.3269 89.0039 19.2578 88.5133 19.2578Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1501 55.6506L88.3998 55.416C86.6859 54.8803 84.8622 55.8353 84.3264 57.5492L82.5401 63.2635C82.0043 64.9774 82.9593 66.8011 84.6732 67.3369L85.4235 67.5714C87.1374 68.1072 88.9611 67.1522 89.4969 65.4383L91.2833 59.724C91.819 58.0101 90.864 56.1864 89.1501 55.6506Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3877 68.0345C86.0356 68.0345 85.6771 67.9841 85.3249 67.8709L84.5765 67.6383C82.7025 67.0534 81.6522 65.0472 82.2371 63.1731L84.0231 57.4565C84.608 55.5825 86.6079 54.5322 88.4882 55.1171L89.2366 55.3498C91.1107 55.9346 92.1609 57.9408 91.5761 59.8149L89.79 65.5315C89.3121 67.0534 87.9034 68.0345 86.3815 68.0345H86.3877ZM85.5136 67.2735C87.0544 67.7577 88.7083 66.8899 89.1926 65.3491L90.9786 59.6325C91.4629 58.0854 90.595 56.4377 89.0542 55.9535L88.3059 55.7208C86.7588 55.2366 85.1111 56.1044 84.6269 57.6452L82.8408 63.3618C82.3566 64.9089 83.2244 66.5566 84.7652 67.0408L85.5136 67.2735Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3302 86.5552L102.148 82.3228L104.971 86.5552L110.606 87.2595L107.084 91.4857L107.789 97.1205L102.852 95.0074L97.2171 97.8249L97.9215 92.19L93.6954 87.9639L99.3302 86.5552Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4499 98.9128L97.2612 92.4164L92.4628 87.618L98.9403 85.9954L102.148 81.1844L105.33 85.9577L111.826 86.769L107.738 91.6743L108.543 98.1267L102.871 95.6929L96.4436 98.9065L96.4499 98.9128ZM94.928 88.2972L98.5881 91.9573L97.9907 96.7369L102.839 94.3156L107.034 96.1143L106.43 91.2907L109.392 87.7375L104.613 87.14L102.16 83.4547L99.7264 87.1023L94.928 88.3035V88.2972Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.751 23.6411L112.568 19.4087L115.392 23.6411L121.027 24.3455L117.505 28.5716L118.209 34.2064L113.273 32.0934L107.638 34.9171L108.342 29.276L104.116 25.0498L109.751 23.6411Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.864 36.0051L107.676 29.5087L102.877 24.7103L109.355 23.0877L112.562 18.2767L115.744 23.05L122.241 23.8613L118.153 28.7666L118.958 35.219L113.285 32.7852L106.858 35.9988L106.864 36.0051ZM105.342 25.3895L109.003 29.0496L108.405 33.8292L113.254 31.4079L117.449 33.2066L116.845 28.383L119.807 24.8298L115.027 24.2323L112.575 20.547L110.141 24.1946L105.349 25.3958L105.342 25.3895Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8674 53.4316L62.6849 49.2054L65.5023 53.4316L71.1434 54.1359L67.6216 58.3621L68.326 64.0032L63.3892 61.8901L57.7544 64.7076L58.4587 59.0664L54.2326 54.8403L59.8674 53.4316Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9809 65.7955L57.7921 59.2991L52.9937 54.5007L59.4713 52.8781L62.6786 48.0671L65.8608 52.8404L72.3572 53.6517L68.2694 58.557L69.0744 65.0094L63.4018 62.5756L56.9746 65.7892L56.9809 65.7955ZM55.459 55.1799L59.1191 58.84L58.5216 63.6196L63.3704 61.1983L67.5651 62.997L66.9613 58.1734L69.9234 54.6202L65.1438 54.0227L62.6912 50.3374L60.2574 53.985L55.4652 55.1862L55.459 55.1799Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.923 22.306C80.0747 21.7749 80.6282 21.4675 81.1593 21.6192L88.1593 23.6192C88.6903 23.7709 88.9978 24.3244 88.8461 24.8554C88.6943 25.3865 88.1408 25.694 87.6098 25.5422L80.6098 23.5422C80.0788 23.3905 79.7713 22.837 79.923 22.306ZM77.923 28.306C78.0747 27.7749 78.6282 27.4675 79.1593 27.6192L86.1593 29.6192C86.6903 29.7709 86.9978 30.3244 86.8461 30.8554C86.6943 31.3865 86.1408 31.6939 85.6098 31.5422L78.6098 29.5422C78.0788 29.3905 77.7713 28.837 77.923 28.306ZM75.923 34.306C76.0747 33.7749 76.6282 33.4675 77.1593 33.6192L84.1593 35.6192C84.6903 35.7709 84.9978 36.3244 84.8461 36.8554C84.6943 37.3865 84.1408 37.694 83.6098 37.5422L76.6098 35.5422C76.0788 35.3905 75.7713 34.837 75.923 34.306ZM102.923 36.306C103.075 35.7749 103.628 35.4675 104.159 35.6192L111.159 37.6192C111.69 37.7709 111.998 38.3244 111.846 38.8554C111.694 39.3865 111.141 39.694 110.61 39.5422L103.61 37.5422C103.079 37.3905 102.771 36.837 102.923 36.306ZM100.923 42.306C101.075 41.7749 101.628 41.4675 102.159 41.6192L109.159 43.6192C109.69 43.7709 109.998 44.3244 109.846 44.8554C109.694 45.3865 109.141 45.694 108.61 45.5422L101.61 43.5422C101.079 43.3905 100.771 42.837 100.923 42.306Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2469,
    height: 91.3021,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(53 18)"
  }))));
};
export default SvgUnlimitedArtists;